<div class="container">
    <div class="block">
        <img src="../../../../assets/images/email.svg" alt=""/>
        <h2>Failed</h2>
        <p>Something went wrong, please try again later. </p>
    </div>
</div>